import { Autocomplete, TextField } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { HiOutlineUser } from "react-icons/hi";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../../contexts/auth";
import "./_header.scss";

function Header() {
    const { cyrcleStorage, setCyrcleStorage, cycles } = useContext(AuthContext);
    const emailUser = JSON.parse(localStorage.getItem("@user")).email;
    const nameUser = JSON.parse(localStorage.getItem("@user")).company_data
        ?.company;
    const [imagePost, setImagePost] = useState(
        JSON.parse(localStorage.getItem("@user")).src_photo
    );
    const navigate = useNavigate();
    const location = useLocation();



    useEffect(() => {
        const pictureBoxImage = document.querySelector(".picture-box-image");

        if (imagePost === null) return;

        const img = document.createElement("img");
        img.src = imagePost;
        img.classList.add("picture-img");
        pictureBoxImage.innerHTML = "";
        pictureBoxImage.appendChild(img);
    }, [imagePost]);

    function postFileInput(e) {
        const headers = {
            Authorization: `Bearer ${localStorage.getItem("@token")}`,
            // "Content-Type": "multipart/form-data",
            Accept: "application/json",
        };

        let formData = new FormData();
        formData.append("photo", e.target.files[0]);

        fetch(`${process.env.REACT_APP_API_URL}/profile/update`, {
            method: "POST",
            headers,
            body: formData,
        })
            .then((response) => response.json())
            .then((response) => {
                localStorage.setItem("@user", JSON.stringify(response.data));
                setImagePost(
                    JSON.parse(localStorage.getItem("@user")).src_photo
                );
            });
    }

    function chooseCyrcleAkatu(idCyrcle) {
        setCyrcleStorage(idCyrcle);
        localStorage.setItem("@cycleChosed", JSON.parse(idCyrcle));
        if (location.pathname !== "/relatorio") {
            navigate("/");
        }
    }

    function getSelected() {
        let index = 0;
        for (let i = 0; i < cycles.length; i++) {
            if (cycles[i].quiz_id == cyrcleStorage) {
                index = i;
            }
        }
        return index;
    }
    return (
        <div className="box-apresentacao-empresa">
            <div className="box-information">
                <div className="box-info-user">
                    <p className="apresentacao__name-empresa">{nameUser}</p>
                    <p className="email-user">{emailUser}</p>
                </div>

                {cycles.length > 0 && (() => {
                    const cyclesWithLabel = cycles.map((el) => ({
                        ...el,
                        label: el.cycle || el.label || String(el.quiz_id),
                    }));
                    const selectedIndex = getSelected();
                    return (
                        <Autocomplete
                            disablePortal
                            disableClearable
                            defaultValue={
                                cyclesWithLabel.length > 1
                                    ? cyclesWithLabel[selectedIndex]
                                    : cyclesWithLabel[0]
                            }
                            id="combo-box-demo"
                            options={cyclesWithLabel}
                            sx={{ width: 200 }}
                            size="small"
                            onChange={(event, value) =>
                                chooseCyrcleAkatu(value.quiz_id)
                            }
                            renderInput={(params) => (
                                <TextField {...params} label="Ciclo acessado" />
                            )}
                        />
                    );
                })()}
            </div>

            <label className="picture-company">
                <input
                    onChange={postFileInput}
                    className="picture-input"
                    id="picture-input"
                    type="file"
                    accept="image/*"
                />
                <span tooltip="Editar imagem" className="picture-box-image">
                    {!imagePost && <HiOutlineUser />}
                </span>
            </label>
        </div>
    );
}

export default Header;

